var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSceneFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1123,
    height: 522,
    viewBox: "0 0 1123 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 38.245C3 17.6774 21.009 1.75644 41.4297 4.25535C139.302 16.2322 388.376 44.4688 561.5 44.4688C734.624 44.4688 983.698 16.2322 1081.57 4.25537C1101.99 1.75645 1120 17.6773 1120 38.245V483.755C1120 504.323 1101.99 520.244 1081.57 517.745C983.698 505.768 734.624 477.531 561.5 477.531C388.376 477.531 139.302 505.768 41.4297 517.745C21.0091 520.244 3 504.323 3 483.755V38.245Z",
    stroke: "white",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSceneFrame);
export default __webpack_public_path__ + "static/media/scene-frame.f7152dea017419b250d7028adc98943c.svg";
export { ForwardRef as ReactComponent };